import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { UserPermissions } from '../types/user-permissions.types';

@Injectable()
export class UserPermissionsService {
  private apiHost: any;

  constructor(
    private httpClient: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) environmentConfig: EnvironmentConfig
  ) {
    this.apiHost = environmentConfig.params['apiHost'];
  }

  public load(): Observable<UserPermissions> {
    const url = `${this.apiHost}/v1/user-permissions`;

    return this.httpClient
      .get(url, {
        observe: 'response'
      })
      .pipe(
        mergeMap((response: HttpResponse<any>) => {
          const data = response.status === 200 && response.body;
          return data
            ? of(this.getUserPermissionsFromResponse(data))
            : throwError(Error('Cannot load User Permissions'));
        })
      );
  }

  getUserPermissionsFromResponse(data: any): UserPermissions {
    const result: UserPermissions = {
      permissions: [],
      ipreoAccountUserId: data.ipreoAccountUserId,
      buysideUserId: data.buysideUserId
    };
    if (data.claims) {
      const permsArray: any[] = Array.isArray(data.claims)
        ? (data.claims as any[])
        : [];
      if (permsArray && permsArray.length) {
        result.permissions = permsArray.map(item => item.value);
      }
    }
    return result;
  }
}
